import client from './client';
import type { ReferralInfo, ReferralStats } from '../types/referral';

export async function getReferralLink(): Promise<ReferralInfo> {
  const { data } = await client.get('/referral/link');
  return data;
}

export async function getReferralStats(): Promise<ReferralStats> {
  const { data } = await client.get('/referral/stats');
  return data;
}
